import type { ViewVariant } from 'src/types/DeviceUI';

/**
 * Picks the Main-tab view variant from the allowed list.
 * Flag off always prefers basic. Flag on uses the session selection when allowed.
 */
export function pickViewVariant(
	allowed: ViewVariant[],
	options: { switcherEnabled: boolean; selected?: ViewVariant },
): ViewVariant {
	if (!allowed.length) return 'basic';
	if (options.switcherEnabled && options.selected && allowed.includes(options.selected)) {
		return options.selected;
	}
	if (allowed.includes('basic')) return 'basic';
	return allowed[0];
}
